export default __webpack_public_path__ + "ea47c0f16d65f22dbc06b4c6ec1d8f32.ttf";